module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_23.bf8e3265.png";